/* istanbul ignore file */
const validTenants = ['socl', 'facl', 'fape', 'faco'];
const isValidTenant = (tenant) => {
  return validTenants.includes(tenant);
};

export default isValidTenant;
